import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../utils/mockData';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'Ürünler', path: '/urunler' },
    { name: 'Üretim Süreçleri', path: '/uretim-surecleri' },
    { name: 'Sertifikalar', path: '/sertifikalar' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-md' 
          : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-14 w-auto object-contain transition-transform group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === link.path
                    ? 'text-lime-600 bg-lime-50'
                    : 'text-gray-700 hover:text-lime-600 hover:bg-lime-50/50'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <Link
            to="/iletisim"
            className="hidden lg:block px-6 py-3 bg-lime-600 text-white rounded-lg font-medium hover:bg-lime-700 transition-all duration-200 hover:shadow-lg hover:scale-105"
          >
            Teklif Alın
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-lime-600 transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200 animate-in slide-in-from-top">
            <nav className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                    location.pathname === link.path
                      ? 'text-lime-600 bg-lime-50'
                      : 'text-gray-700 hover:text-lime-600 hover:bg-lime-50/50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/iletisim"
                onClick={() => setIsMobileMenuOpen(false)}
                className="mx-4 px-6 py-3 bg-lime-600 text-white rounded-lg font-medium text-center hover:bg-lime-700 transition-all"
              >
                Teklif Alın
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
